import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const mediaModalDefaultVariants = {}
const mediaModalCompoundVariants = []

const mediaModalSlotNames = [
  [
    "photoPanel",
    "media-modal__photoPanel"
  ],
  [
    "mainImage",
    "media-modal__mainImage"
  ],
  [
    "photoCountBadge",
    "media-modal__photoCountBadge"
  ],
  [
    "thumbnailRail",
    "media-modal__thumbnailRail"
  ],
  [
    "thumbnailButton",
    "media-modal__thumbnailButton"
  ],
  [
    "thumbnailButtonSelected",
    "media-modal__thumbnailButtonSelected"
  ],
  [
    "thumbnailImage",
    "media-modal__thumbnailImage"
  ],
  [
    "mediaPanel",
    "media-modal__mediaPanel"
  ],
  [
    "iframeStage",
    "media-modal__iframeStage"
  ],
  [
    "iframe",
    "media-modal__iframe"
  ],
  [
    "videoPosterButton",
    "media-modal__videoPosterButton"
  ],
  [
    "videoPosterImage",
    "media-modal__videoPosterImage"
  ],
  [
    "videoPosterFallback",
    "media-modal__videoPosterFallback"
  ],
  [
    "videoPosterScrim",
    "media-modal__videoPosterScrim"
  ],
  [
    "videoPosterOverlay",
    "media-modal__videoPosterOverlay"
  ],
  [
    "videoPlayIcon",
    "media-modal__videoPlayIcon"
  ],
  [
    "mediaItemGrid",
    "media-modal__mediaItemGrid"
  ],
  [
    "mediaItemButton",
    "media-modal__mediaItemButton"
  ],
  [
    "tourCardGrid",
    "media-modal__tourCardGrid"
  ],
  [
    "tourCardGridCompact",
    "media-modal__tourCardGridCompact"
  ],
  [
    "tourCardMedia",
    "media-modal__tourCardMedia"
  ],
  [
    "tourCardMediaCompact",
    "media-modal__tourCardMediaCompact"
  ],
  [
    "tourCardImage",
    "media-modal__tourCardImage"
  ],
  [
    "tourCardFallback",
    "media-modal__tourCardFallback"
  ],
  [
    "tourCardFallbackCompact",
    "media-modal__tourCardFallbackCompact"
  ],
  [
    "tourCardScrim",
    "media-modal__tourCardScrim"
  ],
  [
    "tourCardOverlay",
    "media-modal__tourCardOverlay"
  ],
  [
    "tourCardIcon",
    "media-modal__tourCardIcon"
  ],
  [
    "tourCardIconCompact",
    "media-modal__tourCardIconCompact"
  ],
  [
    "emptyState",
    "media-modal__emptyState"
  ],
  [
    "streetViewCanvas",
    "media-modal__streetViewCanvas"
  ],
  [
    "streetViewStage",
    "media-modal__streetViewStage"
  ],
  [
    "streetViewCanvasHidden",
    "media-modal__streetViewCanvasHidden"
  ],
  [
    "streetViewStatus",
    "media-modal__streetViewStatus"
  ],
  [
    "srOnly",
    "media-modal__srOnly"
  ]
]
const mediaModalSlotFns = /* @__PURE__ */ mediaModalSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, mediaModalDefaultVariants, getSlotCompoundVariant(mediaModalCompoundVariants, slotName))])

const mediaModalFn = memo((props = {}) => {
  return Object.fromEntries(mediaModalSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const mediaModalVariantKeys = []
const getVariantProps = (variants) => ({ ...mediaModalDefaultVariants, ...compact(variants) })

export const mediaModal = /* @__PURE__ */ Object.assign(mediaModalFn, {
  __recipe__: false,
  __name__: 'mediaModal',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: mediaModalVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, mediaModalVariantKeys)
  },
  getVariantProps
})